import { createContext } from 'react';

const UsuarioAppContext = createContext();

export default UsuarioAppContext;
